@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.districtSearchButton {
  width: 100px;
  margin-left: variables.$std-margin-xs;
}

.formInline {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.formGroup {
  margin-bottom: 0;
}

.formInput {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
